import { API, graphqlOperation } from 'aws-amplify'
import { listRequests, getUser } from "../../graphql/queries";
import {getUserMoreRequests} from "@/graphql/custom/queries";

const state = {
    allRequests: [],
    userRequests: [],
};

const getters = {
    allRequests: (state) => state.allRequests,
    userRequests: (state) => state.userRequests
};

const actions = {
    async fetchRequests({ commit, rootGetters }) {
        await API.graphql(graphqlOperation(listRequests, {
            filter: {
                orgID: {
                    eq: rootGetters.getOrgID
                }
            },
            limit: 9999
        }))
            .then(response => {
                const allRequests = response.data.listRequests.items;
                commit('setAllRequests', allRequests);
            });

        await API.graphql(graphqlOperation(getUserMoreRequests, { id: rootGetters.getAppUserID}))
            .then(response => {
                const userRequests = response.data.getUser.requests.items;
                commit('setUserRequests', userRequests);
            })

    }
};

const mutations = {
    setAllRequests: (state, requests) => (state.allRequests = requests),
    setUserRequests: (state, requests) => (state.userRequests = requests)
};

export default {
    state,
    getters,
    actions,
    mutations
}